import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

const { Types, Creators } = createActions({
  getCourseDetail: ['courseId', 'iterableTracking'],
  getCourseDetailSilent: ['courseId'],
  getCourseDetailDone: ['course'],
  getCourseDetailError: ['message'],
  getCourseScorecard: ['courseId'],
  getCourseScorecardDone: ['scorecard'],
  getCourseScorecardError: ['errorMessage'],
});

export const CourseDetailTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable.from({
  isLoading: false,
  isError: false,
  isDone: false,
  errorMessage: '',
  course: {},
  scorecard: null,
  scorecardLady: null,
  isScorecardLoading: false,
  isScorecardDone: false,
  scorecardError: '',
});

const getCourseDetail = () => INITIAL_STATE.merge({
  isLoading: true,
});

const getCourseScorecard = (state) => state.merge({
  isScorecardLoading: false,
  isScorecardDone: false,
  scorecardError: '',
});

const getCourseScorecardDone = (state, { scorecard }) => state.merge({
  ...scorecard,
  isScorecardLoading: false,
  isScorecardDone: true,
  scorecardError: '',
});

const getCourseScorecardError = (state, { errorMessage }) => state.merge({
  isScorecardLoading: false,
  isScorecardDone: true,
  scorecardError: errorMessage,
});

const getCourseDetailDone = (state, { course }) => state.merge({
  isLoading: false,
  isError: false,
  isDone: true,
  course,
});

const getCourseDetailError = (state, { message }) => state.merge({
  isLoading: false,
  isError: true,
  isDone: true,
  errorMessage: message,
});

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_COURSE_DETAIL]: getCourseDetail,
  [Types.GET_COURSE_DETAIL_DONE]: getCourseDetailDone,
  [Types.GET_COURSE_DETAIL_ERROR]: getCourseDetailError,
  [Types.GET_COURSE_SCORECARD]: getCourseScorecard,
  [Types.GET_COURSE_SCORECARD_DONE]: getCourseScorecardDone,
  [Types.GET_COURSE_SCORECARD_ERROR]: getCourseScorecardError,
});
